import { useContext } from 'react';
import { LightswitchContext } from '../components/LightswitchProvider.jsx';

/**
 * React hook for accessing Lightswitch SDK
 * 
 * Provides easy access to SDK functionality and state within React components.
 */


/**
 * Hook to access Lightswitch SDK context
 * @returns {Object} Lightswitch SDK context
 * @throws {Error} If used outside of LightswitchProvider
 */
const useLightswitch = () => {
  const context = useContext(LightswitchContext);
  if (!context) {
    throw new Error('useLightswitch must be used within a LightswitchProvider');
  }
  return {
    ...context,
    // Helper methods for common patterns
    isReadyForAuth: context.isReady && context.isInitialized,
    canMakeAuthenticatedCalls: context.isReady && context.isAuthenticated,
    // Convenience method to wait for ready state
    waitForReady: async function () {
      let timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5000;
      if (context.isReady) return true;
      const startTime = Date.now();
      while (!context.isReady && Date.now() - startTime < timeout) {
        await new Promise(resolve => setTimeout(resolve, 50));
      }
      return context.isReady;
    }
  };
};

export { useLightswitch };
//# sourceMappingURL=useLightswitch.js.map
